import { Flex, Radio, RadioChangeEvent } from 'antd';
import './CalendarItem.css';
import { EditOutlined, SettingOutlined, DeleteOutlined, TeamOutlined, CalendarOutlined } from '@ant-design/icons';
import { Calendar } from '../../models/calendar/Calendar.model';
import { useModalCalendar } from '../../contexts/calendar/ModalCalendarContext.context';
import { useCalendar } from '../../contexts/calendar/CalendarContext.context';
import { useHistory, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useUser } from '../../contexts/UserContext';
import { useCompany } from '../../contexts/CompanyContext';
import { useEffect, useState, useMemo } from 'react';


type Props = {
    calendar: Calendar;
};

const deafultValueOptions = [
        {
            value: 'edit',
            label: (
            <Flex gap="small" justify="center" align="center" style={{ paddingTop: 6 }}>
                <EditOutlined style={{ fontSize: 16 }} />
            </Flex>
            ),
        },
        {
            value: 'configuration',
            label: (
            <Flex gap="small" justify="center" align="center" style={{ paddingTop: 6 }}>
                <SettingOutlined style={{ fontSize: 16 }} />
            </Flex>
            ),
        },                        
        {
            value: 'delete',
            label: (
            <Flex gap="small" justify="center" align="center" style={{ paddingTop: 6 }}>
                <DeleteOutlined style={{ fontSize: 16 }} />
            </Flex>
            ),
        }
    ];

export default function CalendarItem({ calendar }: Props) {
    const { setCalendar } = useCalendar();
    const { setOptions } = useModalCalendar();
    const history = useHistory();
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth()+1)
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const {user} = useUser();
    const {company} = useCompany();
    const [optionsActionsItem,setOptionsActionsItem] = useState(deafultValueOptions);

    const categoryLabel = useMemo(() => {
        console.log("CalendarItem - calendar.category:", calendar.category);
        if (!calendar.category) return 'Genérico (Sin restricción)';
        const found = company.moduleOptions?.find((opt:any) => opt.type === 'EVENT_TYPE' && opt.key === calendar.category);
        return found ? found.string_value : 'Tipo personalizado';
    }, [calendar.category, company.moduleOptions]);

    useEffect(()=>{
        const hasEditPermission = user?.permissions?.views?.includes("calendar.calendars.main.options.view.edit_calendar");
        const hasDeletePermission = user?.permissions?.views?.includes("calendar.calendars.main.options.view.delete_calendar");
        const hasConfigPermissions = user?.permissions?.views?.includes("calendar.calendars.main.options.view.configuration_week"); 
           
        const filteredOptions = deafultValueOptions.filter(option => {
            if (option.value === "edit" && !hasEditPermission) return false;
            if (option.value === "delete" && !hasDeletePermission) return false;
            if (option.value === "configuration" && !hasConfigPermissions) return false;
            return true;
        });
        setOptionsActionsItem(filteredOptions);
        handleActionButtonsAutomatic((searchParams.get("configuration")?'configuration':''),searchParams.get("calendar")!)
    },[user.permissions?.views,search])

    const handleActionButtonsAutomatic = (options:string,id:string) =>{
        switch (options) {
            case 'edit':
                setOptions((prev) => ({
                    ...prev,
                    isopen: true,
                    id: id,
                    isEditing: true,
                    isConfiguration: false,
                    width:"520px"
                }));
                break;
            case 'configuration':
                 setOptions((prev) => ({
                    ...prev,
                    isopen: true,
                    id: id,
                    isEditing: false,
                    isConfiguration: true,
                    width:"520px"
                }));
                break;
            default:
                break;
        }
    }

    const handleActionButtons = (radio:RadioChangeEvent)=> {
        handleActionButtonsAutomatic(radio.target.value,calendar.uid);
    }

    const accentColor = calendar.color || '#1677ff';
    const usersCount = calendar.users?.length || 0;
    const weekDaysCount = calendar.weekAvailable?.filter(d => d)?.length || 0;

    const handleCardClick = () => {
        const weekrules = [false,false,false,false,false,false,false].map((_,i)=>(calendar.weekAvailable.filter((day)=>day.numberDay==i).length>0));
        setCalendar((prev)=>({
            ...prev,
            id: calendar.id,
            uid: calendar.uid,
            color: calendar.color,
            availableWeekRules: weekrules,
            weekAvailable: calendar.weekAvailable,
            customEvents: calendar.customEvents,
            category: calendar.category
        }));
        Cookies.set("calendar_id", calendar.id, {
            expires: 1/24,
            path: "/",
        });
        history.push('/calendar/month/'+currentDate.getFullYear()+'/'+currentDate.getMonth()+'/'+currentDate.getDate()+'?calendar='+calendar.uid);
    };

    return (
        <article className="calendar-selector-item">
            <div className="calendar-item__accent" style={{ backgroundColor: accentColor }} />
            <div className="calendar-item__body" onClick={handleCardClick}>
                <h3 className="calendar-item__name">{calendar.name}</h3>
                <p className="calendar-item__description">{calendar.description}</p>
            </div>
            <div className="calendar-item__meta" style={{display:'flex', flexDirection:'column', gap:'4px'}}>
                <span className="calendar-item__meta-item" style={{fontWeight: 500, color: 'var(--text-color)'}}>
                    {categoryLabel}
                </span>
                <div style={{display:'flex', gap:'8px'}}>
                    <span className="calendar-item__meta-item">
                        <TeamOutlined /> {usersCount} usuario{usersCount !== 1 ? 's' : ''}
                    </span>
                    <span className="calendar-item__meta-item">
                        <CalendarOutlined /> {weekDaysCount} día{weekDaysCount !== 1 ? 's' : ''}/sem
                    </span>
                </div>
            </div>
            <div className="calendar-item__footer" onClick={(e) => e.stopPropagation()}>
                {optionsActionsItem && <Radio.Group 
                    onChange={handleActionButtons}
                    buttonStyle="solid"
                    value={'large'}
                    optionType="button"
                    options={optionsActionsItem}/>}
            </div>
        </article>
    );
}